import { Box, SxProps, Typography } from "@mui/material";
import { Firmware } from "../utils/types";
import { StringId } from "./tablefilters/utils";
import { useFirmwareProperties } from "../hooks/useFirmwareProperties";
import { FormatDateOptions, useIntl } from "react-intl";

export type FirmwareItemProps = {
  item: Firmware | StringId<Firmware>;
  sx?: SxProps;
};

const dateFormatOptions: FormatDateOptions = {
  dateStyle: "short",
  timeStyle: "medium",
};

export const FirmwareItem = ({ item, sx }: FirmwareItemProps) => {
  const { statusValues, urgencyValues } = useFirmwareProperties();
  const { formatMessage, formatDate } = useIntl();

  return (
    <Box
      sx={{
        ...sx,
        flex: 1,
        height: 126,
        m: 0,
        "& .MuiTypography-root": { display: "block", whiteSpace: "nowrap", maxWidth: 1 / 1, overflow: "hidden", textOverflow: "ellipsis" },
      }}
    >
      <Typography variant="subtitle2">
        {item.hwtype}.{item.hwver}
      </Typography>
      <Typography>
        {item.swtype} {item.version ?? item.swver ? `v${item.version ?? item.swver}` : ""}
      </Typography>
      <Typography variant="body2">{item.description}</Typography>
      <Typography color="text.secondary" variant="caption" component="div">
        {formatMessage({ defaultMessage: "Status" })}: {statusValues.get(item.status)}
      </Typography>
      <Typography color="text.secondary" variant="caption" component="div">
        {formatMessage({ defaultMessage: "Urgency" })}: {urgencyValues.get(item.urgency)}
      </Typography>
      <Typography color="text.secondary" variant="caption" component="div">
        {formatDate(item.last_changed_ts, dateFormatOptions)}
      </Typography>
    </Box>
  );
};
